import { createContext, useContext } from 'react'

// API contract only (= 型 + Context default noop + useToast hook).
// Provider 実装 (= Snackbar UI + style) は app 別に物理分離:
//   - apps/latest/shared/contexts/ToastProvider.tsx  → Notion 黒トースト spec
//   - apps/legacy/shared/contexts/ToastProvider.tsx  → 旧 Material 流 (filled MuiAlert)
// App.tsx で AppType 駆動 dispatcher が wrap する.

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface ToastContextValue {
  showToast: (
    message: string,
    type?: ToastType,
    autoHideDuration?: number
  ) => void
  hideToast: () => void
}

const noop = () => {
  // app の ToastProvider が wrap されていない isolated rendering 用 fallback.
  // 実 production flow では App.tsx が必ず AppType dispatcher 経由で Provider を wrap する.
}

export const ToastContext = createContext<ToastContextValue>({
  showToast: noop,
  hideToast: noop,
})

export const useToast = () => useContext(ToastContext)
